import LinkText from "../../../../../components/LinkText";
import { getLabel } from "../../../../../hooks/use-labels";
import { getStyle } from "../../../../../hooks/use-styles";
import { formatCurrency } from "../../../../../utils/common-utils";

import "./style.css";

const AppliedCouponView = ({ onRemove, couponDetails }) => {
  const { value, currency, code } = couponDetails;

  return (
    <div className="applied-coupon-view">
      <div className="font-14-normal-500-lh-18 coupon-code-ellipse ellipse-text">
        {code}
      </div>
      <div className="coupon-remove-text">
        <LinkText text={getLabel('removeLabel')} onClick={onRemove} />
        <span
          className="font-14-normal-400-lh-18"
          style={{ color: getStyle("black") }}
        >
          {formatCurrency(value, currency)}
        </span>
      </div>
    </div>
  );
};

export default AppliedCouponView;
